import rootReducer, { RootState } from "./reducers";
import persistMiddleware from "./middleware/persistMiddleware";
import { composeWithDevTools } from "redux-devtools-extension";
import { applyMiddleware, createStore, Store } from "redux";

const initialState = {};
const store: Store<RootState> = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(persistMiddleware)));

// Expose store globally for debugging and special cases like board initialization
(window as any).__store = store;

export type { RootState };
export default store;
